import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { Redirect, Link } from 'react-router-dom';
import i18n from 'i18n-react';

import {
  APIHandler,
  BackButton,
  Collection,
  DataHandler,
  ImageCollection,
  VideoCollection,
} from 'C4';
import { storageKeys } from 'settings';

const crumbRoutes = {
  '/main': 'Home',
  '/main/promote': 'Promote',
  '/main/promote/london-neighbourhoods': 'London Neighbourhoods',
  '/main/sell': 'Sell',
  '/main/sell/images': 'Image Library',
  '/main/sell/videos': 'Video Library',
  '/main/promote/itineraries': 'Sample Itineraries',
};

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: [],
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    const { url } = this.props.match;
    document.addEventListener('keydown', this.onEsc);
    DataHandler.matchAppId().then((id) => {
      const appId = id;

      if (url.split('/').slice(-1).pop() === 'image-library') {
        DataHandler.checkKey(storageKeys.images, APIHandler.getImages(appId))
          .then(res => this.setState({ collection: res.items }));
      }

      if (url.split('/').slice(-1).pop() === 'videos') {
        DataHandler.checkKey(storageKeys.videos, APIHandler.getVideos(appId))
          .then(({ items }) => {
            const newItems = {};
            Object.keys(items).forEach((key) => {
              const [firstItem] = items[key];
              const { chapter: { chapterNumber } } = firstItem;
              newItems[chapterNumber] = items[key];
            });
            this.setState({ collection: newItems });
          });
      }

      if (url.split('/').slice(-1).pop() === 'videoLibrary') {
        DataHandler.checkKey(storageKeys.videoLibrary, APIHandler.getVideos(appId))
          .then(({ items }) => {
            const newItems = {};
            Object.keys(items).forEach((key) => {
              const [firstItem] = items[key];
              const { chapter: { chapterNumber } } = firstItem;
              newItems[chapterNumber] = items[key];
            });
            this.setState({ collection: newItems });
          });
      }

      if (url.split('/').slice(-1).pop() === 'brochures') {
        DataHandler.checkKey(storageKeys.brochures, APIHandler.getCollection(appId, 'brochures', 'false'))
          .then(res => this.setState({ collection: res.items }));
      }

      if (url.split('/').slice(-1).pop() === 'sales-flyers') {
        DataHandler.checkKey(storageKeys.salesFlyers, APIHandler.getCollection(appId, 'sales-flyers', 'false'))
          .then(res => this.setState({ collection: res.items }));
      }

      if (url.split('/').slice(-1).pop() === 'itineraries') {
        DataHandler.checkKey(storageKeys.itineraries, APIHandler.getCollection(appId, 'itineraries', 'false'))
          .then(res => this.setState({ collection: res.items }));
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  render() {
    const { escaped, collection } = this.state;

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="collection__Container">
        <div className="collection__Background--overlay" />
        {url.split('/').slice(-1).pop() === 'videos' &&
          Object.values(collection).map(chapterVideos => (
            <VideoCollection
              key={chapterVideos[0].chapter.chapterNumber}
              chapter={chapterVideos}
            />
          ))}
        {url.split('/').slice(-1).pop() === 'image-library' &&
          Object.values(collection).map(chapterImages => (
            <ImageCollection
              key={chapterImages[0].chapter.chapterNumber}
              chapter={chapterImages}
              // title={}
            />
          ))}
        {url.split('/').slice(-1).pop() === 'videoLibrary' &&
        Object.values(collection).map(chapterVideos => (
          <VideoCollection
            key={chapterVideos[0].chapter.chapterNumber}
            chapter={chapterVideos}
          />
        ))}
        {url.split('/').slice(-1).pop() === 'itineraries' &&
        Object.values(collection).map(col => (
          <Collection
            key={col[0].chapter.chapterNumber}
            content={col}
          />
        ))}
        {url.split('/').slice(-1).pop() === 'brochures' &&
        Object.values(collection).map(col => (
          <div className="brochures">
            <Collection
              key={col[0].chapter.chapterNumber}
              content={col}
            />
          </div>
        ))}
        {url.split('/').slice(-1).pop() === 'imageLibrary' &&
          Object.values(collection).map(col => (
            <ImageCollection
              key={col[0].chapter.chapterNumber}
              chapter={col}
              custom
            />
          ))}
        {url.split('/').slice(-1).pop() === 'e-guides' &&
          Object.values(collection).map(col => (
            <div className="e-guides">
              <Collection
                key={col[0].chapter.chapterNumber}
                content={col}
              />
            </div>
          ))}
        {url.split('/').slice(-1).pop() === 'sales-flyers' &&
          Object.values(collection).map(col => (
            <div className="sales-flyers">
              <Collection
                key={col[0].chapter.chapterNumber}
                content={col}
              />
            </div>
          ))}
        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
